var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0899 10.2201L11.0899 21.6401C10.9526 21.8621 10.7109 21.998 10.4499 22.0001H10.2499C10.1099 21.9999 9.97608 21.942 9.87995 21.8401C9.78431 21.7379 9.737 21.5995 9.74995 21.4601L10.3099 15.0001H6.73995C6.47135 14.9972 6.22424 14.8528 6.08995 14.6201L5.89995 14.2901C5.80451 14.1335 5.80451 13.9367 5.89995 13.7801L12.8999 2.36012C13.041 2.13209 13.2918 1.99529 13.5599 2.00012H13.7599C13.9 2.00038 14.0338 2.05824 14.1299 2.16012C14.2256 2.2624 14.2729 2.4007 14.2599 2.54012L13.6899 9.00012H17.2599C17.5285 9.00302 17.7757 9.14749 17.9099 9.38012L18.0999 9.71012C18.1923 9.86859 18.1885 10.0654 18.0899 10.2201Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.8f295ffe075f036969885940e1c9b0dd.svg";
export { ForwardRef as ReactComponent };